export default function PricingGuide() {
  const pricingOptions = [
    {
      title: 'One Man With A Van',
      price: '£60',
      period: 'per hour',
      description: 'Ideal for studio apartments and small loads',
      features: [
        '1 bedroom apartment',
        'Man and van included',
        'Single Item collections',
        'Flexible scheduling',
        '2 hours minimum booking required'
      ],
      popular: false
    },
    {
      title: 'Two Man Crew With A Large Van',
      price: '£80',
      period: 'per hour',
      description: 'Complete moving solution for larger homes and offices',
      features: [
        '2-4 bedroom properties',
        '2 professional movers',
        'Flexible scheduling',
        'Insurance included',
        '2 hours minimum booking required'
      ],
      popular: true
    },
    {
      title: 'Two Man Crew With A Luton Van',
      price: '£100',
      period: 'per hour',
      description: 'Complete moving solution for larger homes and offices',
      features: [
        '2-4 bedroom properties',
        '2 professional movers',
        'Flexible scheduling',
        'Insurance included',
        '2 hours minimum booking required'
      ],
      popular: false
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Transparent Pricing</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            No hidden fees, no surprises. Choose the package that fits your needs
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12 max-w-6xl mx-auto">
          {pricingOptions.map((option, index) => (
            <div 
              key={index} 
              className={`relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-8 ${
                option.popular ? 'border-2 border-blue-600 transform scale-105' : 'border border-gray-200'
              }`}
            >
              {option.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-semibold whitespace-nowrap">
                    Most Popular
                  </span>
                </div>
              )}
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{option.title}</h3>
                <div className="mb-2">
                  <span className="text-gray-600 text-lg mr-1">From</span>
                  <span className="text-4xl font-bold text-blue-600">{option.price}</span>
                  <span className="text-gray-600 ml-2">{option.period}</span>
                </div>
                <p className="text-gray-600">{option.description}</p>
              </div>
              <ul className="space-y-4 mb-8">
                {option.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <i className="ri-check-line text-green-600 text-xl"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <button className={`w-full py-3 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap ${
                option.popular 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
              }`}>
                Get Quote
              </button>
            </div>
          ))}
        </div>

        <div className="bg-blue-50 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Need a Custom Quote?</h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Every move is unique. Contact us for a personalized quote based on your specific requirements, distance, and timing.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="tel:+441234567890" className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-all font-semibold flex items-center gap-2 cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line"></i>
              Call for Quote
            </a>
            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-blue-600 px-8 py-3 rounded-lg hover:bg-gray-50 transition-all font-semibold border-2 border-blue-600 cursor-pointer whitespace-nowrap"
            >
              Request Quote Online
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
